<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-15 10:39:35
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-02-15 15:52:59
-->
<template>
  <div>
    <mobile v-if="device == 'm'" />
    <pc v-if="device == 'pc'"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import pc from './pc'
import mobile from './m'
export default {
  name: 'keep-alive-index',
  components: {
    pc,
    mobile
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['device'])
  },
  activated () {
    // console.log(333)
  },
  mounted () {
    // console.log(54545)
  }
}
</script>
